import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import Delta from 'quill-delta';
import { useTranslation } from 'react-i18next';

import { Paragraph, QuillText } from '@treams/treams-ui';
import { LocalizedAttributedString } from 'generated/graphql';

type Props = {
	description: LocalizedAttributedString | null | undefined;
};

export const SelectConversationCardDescription = ({ description }: Props) => {
	const { t } = useTranslation('', { keyPrefix: 'evaluations.create.modal.form.description' });
	const { localize } = useLocalize();

	const emptyLabel = t('empty');

	const isDescriptionEmpty =
		description === undefined ||
		description === null ||
		QuillText.isEmpty(localize(description).text);

	const label = isDescriptionEmpty ? new Delta().insert(emptyLabel) : localize(description).text;

	return (
		<Paragraph>
			<QuillText value={label} />
		</Paragraph>
	);
};
